import { useEffect, useRef } from "react";

export default function useEscapeHandler(
  open: boolean,
  onRequestClose?: () => void
) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) {
      ref.current?.focus();
    }

    if (!onRequestClose) {
      return;
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onRequestClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onRequestClose, open]);
  return ref;
}
